import { render, staticRenderFns } from "./AddUserEnrollmentModal.vue?vue&type=template&id=1398c345&scoped=true&"
import script from "./AddUserEnrollmentModal.vue?vue&type=script&lang=js&"
export * from "./AddUserEnrollmentModal.vue?vue&type=script&lang=js&"
import style0 from "./AddUserEnrollmentModal.vue?vue&type=style&index=0&id=1398c345&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1398c345",
  null
  
)

export default component.exports